import { Submodel } from 'api/v3/aas_core_meta/types';
import { ReferenceCounterVisualizations } from './ReferenceCounterVisualizations';

type ReferenceCounterDetailProps = {
    readonly submodel: Submodel;
};

export function ReferenceCounterDetail(props: ReferenceCounterDetailProps) {
    return (
        <>
            <ReferenceCounterVisualizations submodel={props.submodel} />
        </>
    );
}
